/**
 * Imports
 */
import { Spin } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

/**
 * CONSTANTS
 */
const SPINNER_HEIGHT = '25';

/**
 * Styled components
 */
const Root = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: inherit;
`;
const LoadingWrapper = styled.div`
  position: absolute;
  top: calc(50% - ${SPINNER_HEIGHT}px);
`;

/**
 * Types
 */
export interface SpinnerProps {
  showSpinner: boolean;
}

/**
 * Spinner component
 */
const Spinner: React.FC<SpinnerProps> = ({ showSpinner }) => {
  if (!showSpinner) {
    return null;
  }
  return (
    <Root>
      <LoadingWrapper>
        <Spin />
      </LoadingWrapper>
    </Root>
  );
};

/**
 * Exports
 */
export { Spinner };
